import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 9.026c-.31-.004-.63-.012-.958-.024-.358.012-.706.02-1.042.024V14h2V9.026zM19.406 8H21a2 2 0 0 1 2 2v3a2 2 0 0 1-1 1.732V21a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.268A2 2 0 0 1 1 13v-3a2 2 0 0 1 2-2h1.708a2.432 2.432 0 0 1-.158-.117 3.873 3.873 0 0 1 4.875-6.02c.997.808 2.366 2.414 2.63 5.904.265-3.49 1.637-5.096 2.635-5.904a3.873 3.873 0 0 1 4.874 6.02c-.05.04-.102.079-.158.117zm-4.493 1c-.293.013-.597.022-.913.026V14h7a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-6.087zM9.215 9H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h7V9.024c-.27-.005-.532-.013-.785-.024zM13 15h-2v7h2v-7zm1 0v7h6a1 1 0 0 0 1-1v-6h-7zm-4 0H3v6a1 1 0 0 0 1 1h6v-7zM8.795 2.64A2.873 2.873 0 0 0 5.18 7.106c.76.616 2.794.958 5.893.919-.159-2.733-1-4.35-2.278-5.385zm10.14 4.466a2.873 2.873 0 0 0-3.616-4.466c-1.28 1.037-2.123 2.655-2.282 5.386 3.1.039 5.137-.304 5.898-.92z"
});

var SvgGift = function SvgGift(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgGift;